import React, { useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { httpGetAuditByVendorId } from "../../../service/httpClient";

const AuditTrail = ({vendorId}) => {
    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        httpGetAuditByVendorId(vendorId).then(response => {
            console.log("Response {}", response.data);
            setRowData(response.data);
        }).catch(error => {
            console.log("Error {}", error);
        })
    }, [])

    const columnDefs = useMemo(() => [
        { headerName: "Shop Id", field: "shopId", flex: 1, sortable: true, filter: true },
        { headerName: "Seller Name", field: "sellerName", flex: 1, sortable: true, filter: true },
        { headerName: "DUNS", field: "duns", sortable: true, flex: 1, filter: true, hide: true},
        { headerName: "Audit Message", field: "message", flex: 2, sortable: true, filter: true,wrapText: true, cellStyle: { wordBreak: 'normal' },autoHeight: true,  },        
        { headerName: "Date Modified", field: "modifiedDate", flex: 2, sortable: true, filter: true  },
        { headerName: "Page Modified", field: "pageModified", flex: 2, sortable: true, filter: true  },
        { headerName: "Modified By", field: "modifiedBy", flex: 2, sortable: true, filter: true  },
    ], []);

    return (
        <div className="ag-theme-alpine" style={{ height: 400, width: "100%" }}>
            <AgGridReact
                rowData={rowData}
                columnDefs={columnDefs}
                pagination={true}
                paginationPageSize={10}
                domLayout="autoHeight"
                overlayNoRowsTemplate={'<span>No audit found for this vendor</span>'}
            />
        </div>
    );
};

export default AuditTrail;

